import { useState, ReactNode } from "react";

import { ChevronDown } from "lucide-react";

import { cn } from "@/libs/utils";

import WhiteChevronIcon from "@/assets/images/white-chevron-icon-down.png";

import CommonImg from "@/components/Common/Img";

type AccordionPanelProps = {
  title: string;
  scroll?: boolean;
  children: ReactNode;
};

export default function AccordionPanel({
  title,
  scroll = false,
  children,
}: AccordionPanelProps) {
  const [open, setOpen] = useState(true);

  return (
    <div className="w-full max-w-md rounded-lg border bg-white shadow-sm">
      <button
        onClick={() => setOpen(!open)}
        className={cn(
          "w-full flex items-center justify-between px-5 py-4 bg-dark-brown text-white rounded-t-lg",
          { "rounded-b-lg": !open }
        )}
      >
        <span className="text-sm font-semibold">{title}</span>
        {/*<ChevronDown className={cn({ "rotate-180": open })} />*/}
        <CommonImg
          className={cn("size-5", { "rotate-180": !open })}
          src={WhiteChevronIcon}
          alt="Chevron"
        />
      </button>
      {open && (
        <div
          className={cn("p-4 bg-white rounded-b-lg", {
            "h-[110px] overflow-auto": scroll,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}
